<template>
    <div 
        v-if="$slots.default"
        class="container-with-icon" 
        :class="additionalClass" 
    >
        <div class="icon" v-if="icon">
            <img :src="icon" alt="">
        </div>

        <div class="content" :class="contentClass">
            <h4 v-if="titleType == 'h4'">{{title}}</h4>
            <h3 v-else-if="titleType == 'h3'">{{title}}</h3>
            <h1 v-else>{{title}}</h1>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        title:{
            type:String,
            default:''
        },
        titleType:{
            type:String,
            default:'h4'
        },
        icon:{
            type:String,
            required: false,
        },

        additionalClass:{
            type:String,
            required:false
        },
        contentClass:{
            type:String,
            required:false
        },
    },
}
</script>

